var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViberLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    id: "Layer_1",
    viewBox: "-94.79835 -166.597 821.5857 999.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs199"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style197"
  }, ".cls-1{fill:#fff}.cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:16.86px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path203",
    d: "M560.651 64.998c-16.56-15.28-83.48-63.86-232.54-64.52 0 0-175.78-10.6-261.47 68-47.7 47.71-64.48 117.52-66.25 204.07-1.77 86.55-4.06 248.75 152.29 292.73h.15l-.1 67.11s-1 27.17 16.89 32.71c21.64 6.72 34.34-13.93 55-36.19 11.34-12.22 27-30.17 38.8-43.89 106.93 9 189.17-11.57 198.51-14.61 21.59-7 143.76-22.65 163.63-184.84 20.51-167.17-9.92-272.91-64.91-320.57z",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path205",
    d: "M525.881 98.768c-14-12.72-74.43-50.69-200.52-51.24 0 0-149.31-9.81-221.79 55.84-40.34 39.83-53.93 99.06-55.42 171.34-1.49 72.28-9.21 210.36 123 247.09 0 0-.52 102.51-.58 111.52 0 6.3 1 10.61 4.6 11.5 2.59.63 6.47-.71 9.77-4 21.14-21.23 88.82-102.88 88.82-102.88 90.81 5.93 163.06-12 170.83-14.54 18.32-5.89 117.41-14.4 134.18-149.86 17.33-139.63-6.37-234.94-52.89-274.77z",
    fill: "#7360f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path207",
    d: "M389.471 268.768q-2.46-49.59-50.38-52.09",
    className: "cls-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path209",
    d: "M432.721 283.268q1-46.2-27.37-77.2c-19-20.74-45.3-32.16-79.05-34.63",
    className: "cls-3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path211",
    d: "M477.001 300.588q-.61-80.17-47.91-126.28t-117.65-46.6",
    className: "cls-3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path213",
    d: "M340.761 381.678s11.85 1 18.23-6.86l12.44-15.65c6-7.76 20.48-12.71 34.66-4.81a366.67 366.67 0 0130.91 19.74c9.41 6.92 28.68 23 28.74 23 9.18 7.75 11.3 19.13 5.05 31.13 0 .07-.05.19-.05.25a129.81 129.81 0 01-25.89 31.88c-.12.06-.12.12-.23.18q-13.38 11.18-26.29 12.71a17.39 17.39 0 01-3.84.24 35 35 0 01-11.18-1.72l-.28-.41c-13.26-3.74-35.4-13.1-72.27-33.44a430.39 430.39 0 01-60.72-40.11 318.31 318.31 0 01-27.31-24.22l-.92-.92-.92-.92-.92-.92c-.31-.3-.61-.61-.92-.92a318.31 318.31 0 01-24.22-27.31 430.83 430.83 0 01-40.11-60.71c-20.34-36.88-29.7-59-33.44-72.28l-.41-.28a35 35 0 01-1.71-11.18 16.87 16.87 0 01.23-3.84q1.61-12.89 12.73-26.31c.06-.11.12-.11.18-.23a129.53 129.53 0 0131.88-25.88c.06 0 .18-.06.25-.06 12-6.25 23.38-4.13 31.12 5 .06.06 16.11 19.33 23 28.74a366.67 366.67 0 0119.74 30.94c7.9 14.17 2.95 28.68-4.81 34.66l-15.65 12.44c-7.9 6.38-6.86 18.23-6.86 18.23s23.18 87.73 109.79 109.84z",
    className: "cls-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViberLogo);
export default __webpack_public_path__ + "static/media/viber-logo.14152e55acbc60380e1d1790e774ac57.svg";
export { ForwardRef as ReactComponent };